
<div class="bg-white overflow-hidden sm:rounded-lg w-[26rem]">
  <div class="p-7 w-full space-y-4">
    <div class="text-base flex items-center justify-center">
      <div [class.hidden]="imgLoaded" class="w-60 h-30 bg-gray-200 animate-pulse rounded"></div>
      <img #imgRef class="w-30" 
           [class.hidden]="!imgLoaded"
           alt="" 
           src="../../../assets/images/png/clock_timezone.png"
           (load)="imgLoaded = true"
           (error)="imgLoaded = false" />

    </div>
  
    <div class="space-y-2 w-full flex flex-col items-center justify-center">
      @if (!translationsLoaded) {
        <div class="h-8 w-4/5 bg-gray-200 animate-pulse rounded"></div>
      } @else {
        <h1 class="font-bold primary-font text-2xl">
          {{'text.timezone_changed' | translate}}
        </h1>
      }
  
      @if (!translationsLoaded) {
        <div class="h-5 w-11/12 bg-gray-200 animate-pulse rounded"></div>
        <div class="h-5 w-11/12 bg-gray-200 animate-pulse rounded"></div>
        <div class="h-5 w-11/12 bg-gray-200 animate-pulse rounded"></div>
      } @else {
        <p class="primary-font text-gray-500 text-base text-center">
          {{'text.timezone_changed.description' | translate}}.
          </p>
          <span class="font-medium p-2 inline text-base text-center bg-blue-50 rounded-md text-blue-500">{{userPreferredTimezone}}</span>
        <p class="primary-font text-gray-500 text-base text-center">
          {{'text.timezone_changed.note' | translate}}
        </p>
      }
    </div>
  
    <div class="w-full flex justify-center items-center space-x-3">
      @if (!translationsLoaded) {
        <div class="h-10 w-24 bg-gray-200 animate-pulse rounded-md"></div>
        <div class="h-10 w-24 bg-red-200 animate-pulse rounded-md"></div>
      } @else {
        <button type="button" (click)="handleButtonClick('CANCEL')"
          class="px-4 flex items-center py-2 border hover:border-gray-300 shadow-sm text-gray-600 bg-white text-base font-medium rounded-md btn-small">
          {{'cancel.text' | translate}}
        </button>
        <button type="button" (click)="handleButtonClick('UPDATE')"
          class="inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-primary hover:bg-primary-700 focus:outline-none">
          {{'update' | translate}}
        </button>
      }
    </div>
  </div>
</div>